/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/29/21
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import { Col, Form, FormGroup, Label } from 'reactstrap';
import AnalysisTypeSelect from './AnalysisTypeSelectMenu';
import ConfidenceLevelSelect from './ConfidenceLevelSelectMenu';
import InventorySelect from './InventorySelectMenu';
import PerformanceMetricSelect from './PerformanceMetricSelectMenu';
import ScenarioSelect from './ScenarioSelectMenu';
import ReturnPeriodSelect from './ReturnPeriodSelectMenu';
import { SCENARIO_WITH_FULL_UNCERTAINTY, PROBABALISTIC_ANALYSIS } from 'constants/analysisTypes';

type Props = {
  inventoryId: string,
  analysisType: string,
}
const InventoryPageControlForm = ({ inventoryId, analysisType }: Props) => (
  <Form>
    <FormGroup row>
      <Col>
        <Label htmlFor="inventory">
         Building Inventory
        </Label>
        <InventorySelect />
      </Col>
    </FormGroup>
    <FormGroup row>
      <Col>
        <Label htmlFor="analysisType">
          Analysis Type
        </Label>
        <AnalysisTypeSelect />
      </Col>
    </FormGroup>
    {analysisType === SCENARIO_WITH_FULL_UNCERTAINTY ? (
      <FormGroup row>
        <Col>
          <Label htmlFor="scenario">
            Scenario
          </Label>
          <ScenarioSelect inventoryId={inventoryId} />
        </Col>
      </FormGroup>
    ) : null}
    {analysisType === PROBABALISTIC_ANALYSIS ? (
      <FormGroup row>
        <Col>
          <Label htmlFor="returnPeriod">
            Return Period
          </Label>
          <ReturnPeriodSelect />
        </Col>
      </FormGroup>
    ) : null}
    <FormGroup row>
      <Col>
        <Label htmlFor="performanceMetric">
          Performance Metric
        </Label>
        <PerformanceMetricSelect />
      </Col>
    </FormGroup>
    {analysisType === SCENARIO_WITH_FULL_UNCERTAINTY ? (
      <FormGroup row>
        <Col>
          <Label htmlFor="confidenceLevel">
            Confidence Level
          </Label>
          <ConfidenceLevelSelect />
        </Col>
      </FormGroup>
    ) : null}
  </Form>
);

export default InventoryPageControlForm;



// WEBPACK FOOTER //
// ./js/components/pages/Inventory/InventoryPageControlForm/InventoryPageControlForm.jsx